import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/popup.css";

export default function Block_User() {
  const navigate = useNavigate();
  const location = useLocation();
  const user_id = location.state.id;
  const [data, getData] = useState([]);
  const token = JSON.parse(sessionStorage.getItem("userToken"));

  const BlockUser = async () => {
    try {
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_block/block_user",
        {
          method: "POST",

          body: JSON.stringify({
            token: token,
            user_id: user_id,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      const result = await response.json();
      //console.log(result.user);
      getData(result.user);
      //console.log('got here');
      //console.log(result);
      //console.log(data.vehicle_details, data.bank_details);

      if (response.status === 200) {
        //console.log('data gotten succesfully');
      } else {
        //console.log('some error occurred');
      }
    } catch (error) {
      //console.log(error);
    }
  };

  return (
    <div className="popup">
      <div className="popup-container">
        <div className="popup-background">
          <div className="popup-confirmation">
            <div className="popup-confirmation-info">
              Block user Confirmation
            </div>
            <div className="popup-rematched">
              Are you sure you want to block this<br></br> user?
            </div>
          </div>
          <div className="popup-dialog-row">
            <div
              className="popup-dialog"
              onClick={() => navigate("/App/Users")}
            >
              No
            </div>
            <div className="middle-line">
              <hr className="popup-hr"></hr>
            </div>
            <div
              className="popup-dialog1"
              onClick={() => {
                BlockUser();
                navigate("/App/Users");
              }}
            >
              Yes
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
